import React, { useState, useEffect } from "react";
import ReactExport from "react-data-export";
import Styles from './Styles';
import IconButton from '../../../buttons/IconButton';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Download = props => {
    const [ dataSet, setDataSet ] = useState([{
        columns:[],
        data:[]
    }]);

    useEffect(() => {
        formatData();
    },[props.data])

    if (props.loading) {
        return null
    };

    const formatData = () => {
        let label;
        if (props.data.length > 0) {
            label = Object.keys(props.data[0]);
        } else {
            label = Object.keys([]);
        };
    
        const columns = label.reduce((r,i) => {
            r.push({
                title:i, 
                style:Styles.shippingDetailLabelStyle
            });
            return r;
        },[]);
    
        let totalItem = props.data.length;
        let totalPrice = 0; 
        let totalDiscount = 0; 
        let totalBasicPrice = 0;
        let style = Styles.shippingDetailRowLightStyle;
        const data = props.data.reduce((r,i,idx) => {
            let prevItem = idx === 0 ? props.data[0] : props.data[idx-1]
            let currentItem = props.data[idx];
      
            if (idx === 0) {
                totalPrice =  currentItem.price;
                totalDiscount =  currentItem.discount_price;
                totalBasicPrice =  currentItem.basic_price;
            };
    
            if (prevItem.order_id === currentItem.order_id) {
                style = style
            } else {
                totalPrice = totalPrice + currentItem.price;
                totalDiscount = totalDiscount + currentItem.discount_price;
                totalBasicPrice = totalBasicPrice + currentItem.basic_price;
                style = style === Styles.shippingDetailRowLightStyle ? Styles.shippingDetailRowDarkStyle : Styles.shippingDetailRowLightStyle;
            };
    
            r.push([
                {value:i.no || "", style},
                {value:i.id || "", style},
                {value:i.first_name || "", style},
                {value:i.last_name || "", style},
                {value:i.phone || "", style},
                {value:i.organization_name || "", style},
                {value:i.couriers || "", style},
                {value:i.created_date || "", style},
                {value:i.created_time || "", style}
            ]);
            
            return r;
        },[])
        setDataSet([{
            columns,
            data
        }])
    }

    return (
            <ExcelFile 
                filename={props.filename} 
                element={
                    <IconButton iconClassName="fas fa-file-download">
                        Download
                    </IconButton>
                }
            >
                <ExcelSheet dataSet={dataSet} name="Shipping Details"/>
            </ExcelFile>
    );
}

export default Download;